import { useEffect, useState } from 'react'
import ListaEnvioEmailHttp from '../../../../../services/api/https/registration/lista-envio-email.http'
import { getTps } from '../../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../../services/util/error.service'

export const EMAIL_FIELDS_NAME = {
  NOME: 'nome',
  EMAIL: 'email',
  TPS: 'tps',
}
export const EmailAction = {
  LOADING_SALVANDO_EMAIL: 'LOADING_SALVANDO_EMAIL',
  LOADING_APAGANDO_EMAIL: 'LOADING_APAGANDO_EMAIL',
  LOADING_CARREGANDO_EMAILS: 'LOADING_CARREGANDO_EMAILS',
  LOADING_NONE: 'LOADING_NONE',
}

const EMAIL_INIT = { id: null, nome: '', email: '', tpsSelecionados: [] }

export default function useEmailState(listaId) {
  const [emailData, setEmailData] = useState(EMAIL_INIT)
  const [listaTps] = useState(getTps(false).map(tp => ({ value: tp.id, label: tp.name })))
  const [erro, setErro] = useState(null)
  const [loading, setLoading] = useState(EmailAction.LOADING_NONE)
  const [listaEmails, setListaEmails] = useState([])

  useEffect(() => {
    listaId && fetchEmails()
  }, [listaId])

  // Events
  function onMenuItemClicked(menuItem, incomingEmail) {
    if (menuItem === 'Editar') {
      const { id, name, email, tps } = incomingEmail
      const tpsSelecionados = tps ? tps.map(t => t.tp_id) : []
      setEmailData({ id, nome: name, email, tpsSelecionados })
    } else {
      // Excluir
      apagarEmail(incomingEmail)
    }
  }

  function onFieldChange(fieldName, value) {
    switch (fieldName) {
      case EMAIL_FIELDS_NAME.EMAIL:
        setEmailData({ ...emailData, email: value })
        break
      case EMAIL_FIELDS_NAME.NOME:
        setEmailData({ ...emailData, nome: value })
        break
      case EMAIL_FIELDS_NAME.TPS:
        setEmailData({ ...emailData, tpsSelecionados: value })
        break
      default:
        break
    }
  }

  async function onBtnSalvarClick() {
    try {
      setLoading(EmailAction.LOADING_SALVANDO_EMAIL)
      const { id, tpsSelecionados, nome, email } = emailData
      const tps = tpsSelecionados.length === 0 ? null : tpsSelecionados.join(',')
      let savedEmail = await ListaEnvioEmailHttp.salvarEmail(id, listaId, email, nome, tps)
      savedEmail = { ...savedEmail, tpNomes: buildTpNomes(savedEmail) }

      setEmailData(EMAIL_INIT)

      setListaEmails(prevLista => {
        const index = prevLista.findIndex(l => l.id === savedEmail.id)
        if (index !== -1) {
          prevLista[index] = savedEmail
        } else {
          prevLista.push(savedEmail)
        }
        return [...prevLista]
      })
    } catch (error) {
      setErro(errorHandler(error))
    } finally {
      setLoading(EmailAction.LOADING_NONE)
    }
  }

  function onBtnLimparClick() {
    setEmailData(EMAIL_INIT)
  }

  function resetErro() {
    setErro(null)
  }

  // Helpers
  function buildTpNomes(email) {
    if (!email.tps) return ''
    if (!Array.isArray(email.tps)) return ''
    return email.tps.map(tp => tp.tp_name).join(', ')
  }
  async function fetchEmails() {
    try {
      setLoading(EmailAction.LOADING_CARREGANDO_EMAILS)
      const savedEmails = await ListaEnvioEmailHttp.getEmails(listaId)
      setListaEmails(savedEmails.map(email => ({ ...email, tpNomes: buildTpNomes(email) })))
    } catch (error) {
      setErro(errorHandler(error))
    } finally {
      setLoading(EmailAction.LOADING_NONE)
    }
  }
  async function apagarEmail(email) {
    try {
      setLoading(EmailAction.LOADING_APAGANDO_EMAIL)
      await ListaEnvioEmailHttp.apagarEmail(email.id)
      setListaEmails(listaEmails.filter(e => e.id !== email.id))
    } catch (error) {
      setErro(errorHandler(error))
    } finally {
      setLoading(EmailAction.LOADING_NONE)
    }
  }
  // Exports
  return {
    emailData,
    listaEmails,
    listaTps,
    erro,
    loading,
    onMenuItemClicked,
    onFieldChange,
    resetErro,
    onBtnSalvarClick,
    onBtnLimparClick,
  }
}
